/* theme.liquid inline script (was L1438) */
(function () {
      // ── 1. Headline word reveal ──────────────────────────────────────
      function splitHeadlines() {
        // Target major section headings (skip if already split or inside a small element)
        var headings = document.querySelectorAll(
          'section h1, section h2, [class*="content-tabs-heading"], [class*="section-heading"]'
        );
        headings.forEach(function (h) {
          if (h.dataset.optSplit) return;
          if (h.querySelector('img, svg, video, .global-accent-text')) {
            // Has nested elements with their own styling — wrap text nodes only
            wrapTextNodes(h);
          } else {
            // Pure text — split into words
            var text = h.textContent.trim();
            if (!text || text.length > 200) return; // skip long blocks
            var words = text.split(/\s+/);
            h.innerHTML = words.map(function (w, i) {
              return '<span class="opt-word" style="transition-delay:' + (i * 50) + 'ms">' + w + '</span>';
            }).join(' ');
          }
          h.classList.add('opt-headline-reveal');
          h.dataset.optSplit = '1';
        });
      }
      function wrapTextNodes(parent) {
        // Walk text nodes only, wrap each word in a .opt-word span
        var walker = document.createTreeWalker(parent, NodeFilter.SHOW_TEXT, null);
        var nodes = [];
        var n;
        while ((n = walker.nextNode())) {
          if (n.textContent.trim()) nodes.push(n);
        }
        var globalIdx = 0;
        nodes.forEach(function (node) {
          var frag = document.createDocumentFragment();
          var parts = node.textContent.split(/(\s+)/);
          parts.forEach(function (part) {
            if (!part.trim()) {
              frag.appendChild(document.createTextNode(part));
            } else {
              var span = document.createElement('span');
              span.className = 'opt-word';
              span.style.transitionDelay = (globalIdx * 50) + 'ms';
              span.textContent = part;
              frag.appendChild(span);
              globalIdx++;
            }
          });
          node.parentNode.replaceChild(frag, node);
        });
      }
      function observeHeadlines() {
        var headlines = document.querySelectorAll('.opt-headline-reveal');
        if (!headlines.length || !('IntersectionObserver' in window)) {
          headlines.forEach(function (h) { h.classList.add('opt-headline-in'); });
          return;
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('opt-headline-in');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.2, rootMargin: '0px 0px -50px 0px' });
        headlines.forEach(function (h) { io.observe(h); });
        // opt-reveal-fix v1: elements already in the viewport reveal IMMEDIATELY —
        // never leave above-the-fold headings blank waiting for a scroll event
        headlines.forEach(function (h) {
          var r = h.getBoundingClientRect();
          if (r.top < (window.innerHeight || document.documentElement.clientHeight) && r.bottom > 0) {
            h.classList.add('opt-headline-in');
          }
        });
        // Safety net
        setTimeout(function () {
          document.querySelectorAll('.opt-headline-reveal:not(.opt-headline-in)').forEach(function (h) {
            h.classList.add('opt-headline-in');
          });
        }, 1500);
      }

      // ── 2. Number count-up ───────────────────────────────────────────
      function findCountableNumbers() {
        // Auto-detect numbers worth counting: standalone "12,345" style numbers,
        // percentages, "1 in 3", day counts in big headings/spans.
        // Heuristic: text content matches a pure number-like pattern AND parent
        // looks like a stat (large font, isolated).
        var candidates = document.querySelectorAll(
          '[class*="statistic"] [class*="number"], [class*="counter"], [data-counter], .opt-counter, [class*="stat-value"]'
        );
        return candidates;
      }
      function animateCount(el) {
        var raw = (el.dataset.target || el.textContent || '').trim();
        var match = raw.match(/^(\d[\d,]*)\s*(%|\+|k|K|M)?$/);
        if (!match) return;
        var target = parseInt(match[1].replace(/,/g, ''), 10);
        var suffix = match[2] || '';
        var hasComma = match[1].indexOf(',') !== -1;
        if (isNaN(target) || target < 5) return; // skip trivially small
        var duration = Math.min(1800, 600 + target.toString().length * 200);
        var start = performance.now();
        function step(now) {
          var t = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
          var current = Math.floor(eased * target);
          var formatted = hasComma ? current.toLocaleString('en-US') : current;
          el.textContent = formatted + suffix;
          if (t < 1) requestAnimationFrame(step);
        }
        el.dataset.optCounted = '1';
        requestAnimationFrame(step);
      }
      function observeCounters() {
        var els = findCountableNumbers();
        if (!els.length || !('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !e.target.dataset.optCounted) {
              animateCount(e.target);
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.4 });
        els.forEach(function (el) { io.observe(el); });
      }

      // ── 5. Smooth anchor scroll (CSS handles this; JS adds offset for sticky) ──
      // Already handled by html { scroll-behavior: smooth } + scroll-padding-top
      // in the CSS above. JS-fallback for older browsers omitted (target audience
      // is modern phones / laptops).

      function init() {
        splitHeadlines();
        observeHeadlines();
        observeCounters();
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();
/* theme.liquid inline script (was L1596) */
(function(){
    // Sale ends at this date/time (visitor's local time). Change to extend the sale.
    var DEADLINE = new Date('2026-06-07T23:59:59').getTime();
    function pad(n){return n<10?'0'+n:''+n;}
    function tick(){
      var els=document.querySelectorAll('.opt-sale-countdown, .announcement-bar-section span');
      if(!els.length) return;
      var diff=DEADLINE-Date.now();
      var txt;
      if(diff<=0){ txt='ending soon'; }
      else {
        var d=Math.floor(diff/86400000),
            h=Math.floor(diff%86400000/3600000),
            m=Math.floor(diff%3600000/60000),
            s=Math.floor(diff%60000/1000);
        txt=(d>0?d+'d ':'')+pad(h)+'h '+pad(m)+'m '+pad(s)+'s';
      }
      for(var i=0;i<els.length;i++) els[i].textContent=txt;
    }
    tick(); setInterval(tick,1000);
  })();

/* opt-cv-release v1 (2026-09-07) — content-visibility:auto (optistasis-overrides-head.css) skips below-fold sections while the page
   loads, which is where the LCP/main-thread win comes from. But a section that is still skipped when a visitor flings the page shows
   as a blank cream block until the renderer catches up. So after load (or on the first scroll, whichever comes first) every skipped
   section is switched to content-visibility:visible one at a time in idle callbacks — no long task, page fully rendered afterwards. */
(function () {
  var released = false;
  function release() {
    if (released) return; released = true;
    var list = [];
    var all = document.querySelectorAll('.shopify-section');
    for (var i = 0; i < all.length; i++) { if (getComputedStyle(all[i]).contentVisibility === 'auto') list.push(all[i]); }
    var idx = 0;
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 32); };
    function next() {
      if (idx >= list.length) return;
      list[idx++].style.contentVisibility = 'visible';
      idle(next, { timeout: 250 });
    }
    next();
  }
  function afterLoad() { setTimeout(release, 600); }
  if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad);
  window.addEventListener('scroll', release, { once: true, passive: true });
  window.addEventListener('touchstart', release, { once: true, passive: true });
  setTimeout(release, 6000);
})();
